import CardModal from '../CardModal';
import More from '../More';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';
import SVGMore from '@/components/UI/svg/corporatesocialresponsibility/SVGMore';

export default function C() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [moreVisible, setMoreVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    const cards: any = [
        {
            title: t('secC_card19_text'),
            desc: t('secC_card19_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg',
            imgArr: [
                ['https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg'],
            ],
        },
        {
            title: t('secC_card20_text'),
            desc: t('secC_card20_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg',
            imgArr: [
                ['https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg'],
            ],
        },
        {
            title: t('secC_card14_text'),
            desc: t('secC_card14_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg']],
        },
        {
            title: t('secC_card15_text'),
            desc: t('secC_card15_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg']],
        },
    ];

    const moreArr: any = [
        {
            title: t('secC_card2_text'),
            desc: t('secC_card2_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_3.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_3.jpg')],
            ],
        },
        {
            title: t('secC_card3_text'),
            desc: t('secC_card3_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/3_3.webp'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/3_3.png'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_3.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_3.png')],
            ],
        },
        {
            title: t('secC_card4_text'),
            desc: t('secC_card4_desc'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg')],
            ],
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_5_1.png')],
            ],
            title: t('secC_card5_text'),
            desc: t(`secC_card5_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_6_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_6_1.png')],
            ],
            title: t('secC_card6_text'),
            desc: t(`secC_card6_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_7_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_7_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_7_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_7_2.png')],
            ],
            title: t('secC_card7_text'),
            desc: t(`secC_card7_desc`),
        },
        {
            isVideo: true,
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_8_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_8_1.png')],
            ],
            video: ['/video/corporate-social-responsibility/pc/6_1.mp4'],
            title: t('secC_card8_text'),
            desc: t(`secC_card8_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_9_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_9_1.png')],
            ],
            title: t('secC_card9_text'),
            desc: t.rich(`secC_card9_desc`, {
                link: (text: string) => (
                    <a className="desc-link" href={'https://www.ecoflow.com/jp/support-for-disaster-prevention'} target={'_blank'} rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_10_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_10_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_10_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_10_2.png')],
            ],
            title: t('secC_card10_text'),
            desc: t(`secC_card10_desc`),
        },
        {
            title: t('secC_card13_text'),
            desc: t('secC_card13_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_3.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_3.jpg')],
            ],
        },
        {
            title: t('secC_card1_text'),
            desc: t('secC_card1_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_1_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_1_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_1_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_1_2.jpg')],
            ],
        },
        {
            title: t('secC_card16_text'),
            desc: t('secC_card16_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734489723128/F5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489723128/F5.jpg']],
        },
        {
            title: t('secC_card17_text'),
            desc: t.rich(`secC_card17_desc`, {
                link: (text: string) => (
                    <a className="desc-link" href={'https://ventadecolchones.com/'} target={'_blank'} rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734490844937/F6.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734490844937/F6.jpg']],
        },
        {
            title: t('secC_card18_text'),
            desc: t('secC_card18_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734490908713/F7.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734490908713/F7.jpg']],
        },
        {
            title: t('secC_card11_text'),
            desc: t('secC_card11_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/D1.jpg'), require('@publicLocal/corporate-social-responsibility/common/D1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D2.jpg'), require('@publicLocal/corporate-social-responsibility/common/D2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D3.jpg'), require('@publicLocal/corporate-social-responsibility/common/D3.jpg')],
            ],
        },
        {
            title: t('secC_card12_text'),
            desc: t('secC_card12_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/E1.jpg'), require('@publicLocal/corporate-social-responsibility/common/E1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E2.jpg'), require('@publicLocal/corporate-social-responsibility/common/E2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E3.jpg'), require('@publicLocal/corporate-social-responsibility/common/E3.jpg')],
            ],
        },
        {
            title: t('secC_card21_text'),
            desc: t('secC_card21_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491447759/F12.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491447759/F12.jpg']],
        },
    ];

    const new_add_site_25_08_21 = ['eu', 'cn', 'fr', 'de', 'es', 'it', 'jp', 'us', 'ca', 'za', 'au', 'uk', 'mx'];
    if (new_add_site_25_08_21.includes(locale)) {
        cards[0] = {
            title: t('secC_card24_text'),
            desc: t('secC_card24_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
            imgArr: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                ],
            ],
        };
        cards[1] = {
            title: t('secC_card22_text'),
            desc: t('secC_card22_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg']],
        };
        cards[3] = {
            title: t('secC_card23_text'),
            desc: t('secC_card23_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg']],
        };
        moreArr.push({
            title: t('secC_card19_text'),
            desc: t('secC_card19_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg']],
        });
        moreArr.push({
            title: t('secC_card20_text'),
            desc: t('secC_card20_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg']],
        });
        moreArr.push({
            title: t('secC_card15_text'),
            desc: t('secC_card15_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg']],
        });
    }

    return (
        <div className={`csr-C ${css['csr-C']}`}>
            <div className="secC">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secC_title')}</p>
                        <p className="desc">{t('secC_desc')}</p>
                    </div>
                    <div className="card-box">
                        {cards?.map((card: any, k: number) => (
                            <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                <div className="img">
                                    <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                </div>
                                <div className="text-bar">
                                    <p className="text">{card?.title}</p>
                                    <SVGArrow />
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="more" onClick={() => setMoreVisible(true)}>
                        <span className="more-text">{t('secCommon_more')}</span>
                        <SVGMore />
                    </p>
                </div>
            </div>
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}
            {moreVisible && <More arr={moreArr} onClose={() => setMoreVisible(false)} />}
        </div>
    );
}
